import * as React from "react";
import { Info } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Alert, AlertDescription } from "@/components/ui/alert";
const additionalCosts = [{
  item: "Flights to and from the destination clinic",
  cost: "Variable"
}, {
  item: "Accommodation (if choosing to stay outside the clinic's provided facilities)",
  cost: "From €60 / night"
}, {
  item: "Personal daily expenses (food, local transport, leisure)",
  cost: "Variable"
}, {
  item: "Comprehensive Travel Insurance",
  cost: "From €25"
}, {
  item: "Accompanying person's travel and accommodation",
  cost: "Variable"
}];
export default function AdditionalCostsNotCoveredByHse() {
  return <section id="additional-costs-not-covered-by-hse" className="w-full py-16 md:py-24 bg-accent/40">
      <div className="mx-auto max-w-[800px] px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Additional Costs Not Covered by HSE
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            While your medical treatment may be reimbursable, please be aware of these typical out-of-pocket expenses.
          </p>
        </div>

        <div className="rounded-lg border border-ring/20 bg-background shadow-sm overflow-hidden">
          <Table className="[&_tr]:border-ring/20">
            <TableHeader>
              <TableRow className="hover:bg-transparent">
                <TableHead className="w-2/3 p-6 font-default text-lg font-semibold text-foreground">
                  Item
                </TableHead>
                <TableHead className="w-1/3 p-6 font-default text-lg font-semibold text-foreground text-right">
                  Estimated Cost
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {additionalCosts.map((cost, i) => <TableRow key={i} data-index={i} className="hover:bg-accent/20 transition-colors">
                  <TableCell className="p-6 text-base text-muted-foreground">
                    {cost.item}
                  </TableCell>
                  <TableCell className="p-6 text-base font-medium text-foreground text-right">
                    {cost.cost}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <Alert className="mt-8 border-ring/50 bg-background/60 backdrop-blur-sm shadow-sm">
          <Info className="size-5 text-ring" />
          <AlertDescription className="text-sm md:text-base text-foreground/80 leading-relaxed">
            <strong>Note on Flight Prices:</strong> Flight costs are highly variable and depend significantly on the time of booking, chosen airline, and travel season. We strongly recommend booking your flights well in advance to secure the most favorable rates.
          </AlertDescription>
        </Alert>
      </div>
    </section>;
}